import { TabBar } from 'antd-mobile';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { BookingWidget } from 'components/booking-widget';
import DrawerBarcode from 'components/global/DrawerBarcode';
import { Row, Space, Typography } from 'antd';
import useTranslations from 'hooks/useTranslations';
import { InfoCircleOutlined } from '@ant-design/icons';
import DynamicIcon from '../dynamic-icon';

const { Text } = Typography;

const BOTTOM_BAR_DATA = [
    { key: 'home', path: '/', title: 'Home', iconName: 'home', type: 'guest' },
    { key: 'therapist', path: '/therapist', title: 'Therapist', iconName: 'therapist', type: 'guest' },
    { key: 'mybooking', path: '/mybooking', title: 'My Booking', iconName: 'booking', type: 'guest' },
    { key: 'about-us', path: '/about-us', title: 'About Us', iconName: 'aboutus', type: 'guest' },
    { key: 'customersupport', path: '/cs', title: 'Contact CS', iconName: 'headset', type: 'guest' },
    { key: 'home', path: '/therapist/home', title: 'Home', iconName: 'home', type: 'therapist' },
    { key: 'my-booking', path: '/therapist/my-booking', title: 'Booking', iconName: 'booking', type: 'therapist' },
    { key: 'wallet', path: '/therapist/wallet', title: 'Wallet', iconName: 'wallet', type: 'therapist' },
    { key: 'my-profile', path: '/therapist/my-profile', title: 'Profile', iconName: 'profile', type: 'therapist' },
];

const TabBarStyled = styled(TabBar)`
    position: fixed;
    z-index: 999;
    bottom: 0;
    max-width: 430px;
    width: 100%;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    .adm-tab-bar-wrap {
        padding: 12px 0px 0px 0px;
    }
    .tabbar-icon.active::after {
        content: '';
        position: absolute;
        top: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 6px;
        height: 6px;
        background-color: var(--adm-color-primary);
        border-radius: 50%;
    }
    .tabbar-icon.active::after {
        animation: dot-pop 0.3s ease-out;
    }

    @keyframes dot-pop {
        from {
            transform: translateX(-50%) scale(0.5);
            opacity: 0;
        }
        to {
            transform: translateX(-50%) scale(1);
            opacity: 1;
        }
    }
`;

const BottomBarSpacer = styled.div`
    height: 64px;
`;

function BottomBar() {
    const navigate = useNavigate();
    const { t } = useTranslations();

    const [showDrawerCustomerSupport, setShowDrawerCustomerSupport] = useState(false);

    const { pathname } = useLocation() || {};

    const textNeedHelpWithYourBookingOrServices = t('NeedHelpWithYourBookingOrService', 'Need help with your booking services');
    const textCustomerSupport = t('CustomerSupport', 'Customer Support');

    const checkIsActive = (key) => {
        return activeKey?.replaceAll('-', '')?.includes(key) ? `${key}filled` : key;
    };

    const isTherapistMenu = useMemo(() => pathname?.startsWith('/therapist/'), [pathname]);

    const activeKey = useMemo(() => {
        const isTherapistMenu = pathname?.startsWith('/therapist/');
        const parts = pathname?.split('/');
        const currentPath = isTherapistMenu ? parts[2] : parts[parts.length - 1];

        const _pathname = currentPath?.split('.')?.[2] || currentPath;

        return _pathname || 'home';
    }, [pathname]);

    const dataMenuBar = useMemo(() => {
        const type = isTherapistMenu ? 'therapist' : 'guest';
        return BOTTOM_BAR_DATA?.filter((item) => item?.type === type);
    }, [isTherapistMenu]);

    return (
        <>
            <BottomBarSpacer />
            {isTherapistMenu && <BookingWidget />}
            <TabBarStyled activeKey={activeKey} style={{ boxShadow: '0px 0px 16px rgba(168, 216, 243, 0.5)' }}>
                {dataMenuBar?.map((item) => {
                    return (
                        <TabBar.Item
                            key={item?.key}
                            onClick={() => {
                                if (item?.key === 'customersupport') {
                                    setShowDrawerCustomerSupport(true);
                                } else {
                                    navigate(item?.path);
                                }
                            }}
                            icon={
                                <div className={`tabbar-icon ${activeKey === item?.key ? 'active' : ''}`}>
                                    <DynamicIcon iconName={checkIsActive(item?.iconName)} />
                                </div>
                            }
                            title={item?.title}
                        />
                    );
                })}
            </TabBarStyled>
            <DrawerBarcode title={textCustomerSupport} visible={showDrawerCustomerSupport} onClose={() => setShowDrawerCustomerSupport(false)}>
                <div style={{ background: '#DFF8F5', padding: 8 }}>
                    <Row style={{ gap: 16 }} wrap={false} align="top">
                        <InfoCircleOutlined style={{ color: 'var(--primary-color)', padding: '8px 0' }} />
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <Text strong style={{ fontSize: 16 }}>
                                {textNeedHelpWithYourBookingOrServices}
                            </Text>
                            <Text>
                                Our customer support is ready to assist you via <Text strong>LINE, WhatsApp, WeChat, or Telegram</Text>. Simply click
                                one of the available contact options to start chatting with us.
                            </Text>
                        </Space>
                    </Row>
                </div>
            </DrawerBarcode>
        </>
    );
}

export default BottomBar;
